import React from 'react';
import { Instagram, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer
      className="relative"
      style={{
        backgroundColor: 'var(--color-carbon)',
        borderTop: '1px solid var(--color-dark-gray)',
        padding: 'var(--spacing-xl) 0 var(--spacing-md) 0'
      }}>

      <div className="container-artworld">
        {/* Main Footer Content */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

          {/* Brand Column */}
          <div>
            <h3
              className="hero-title mb-4"
              style={{
                fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
                background: 'linear-gradient(135deg, #ffffff 0%, #c0c0c0 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>

              W SHOOT
            </h3>
            <p className="body-text mb-4">
              Photographie automobile d'exception. Capturez l'âme des machines légendaires.
            </p>
            <div className="flex items-center gap-2 text-gray-400">
              <MapPin size={16} />
              <span className="caption-text">Bretagne, France</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="label-text mb-4"
              style={{ color: 'var(--color-white)', fontSize: '0.875rem' }}>

              Navigation
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="caption-text hover:text-white transition-colors duration-300"
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0
                  }}>

                  À Propos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="caption-text hover:text-white transition-colors duration-300"
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0
                  }}>

                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="caption-text hover:text-white transition-colors duration-300"
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0
                  }}>

                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('partners')}
                  className="caption-text hover:text-white transition-colors duration-300"
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0
                  }}>

                  Partenaires
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4
              className="label-text mb-4"
              style={{ color: 'var(--color-white)', fontSize: '0.875rem' }}>

              Services
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="caption-text">Shooting Particulier</li>
              <li className="caption-text">Shooting Supercar</li>
              <li className="caption-text">Shooting Moto</li>
              <li className="caption-text">Shooting Événement</li>
              <li className="caption-text">Photos pour Vente</li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4
              className="label-text mb-4"
              style={{ color: 'var(--color-white)', fontSize: '0.875rem' }}>

              Suivez-nous
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="https://www.instagram.com/w_shoot_22/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 caption-text hover:text-white transition-colors duration-300 group">

                <div
                  className="p-2 rounded-full border border-gray-700 group-hover:border-white transition-colors duration-300">

                  <Instagram size={20} />
                </div>
                <span>@w_shoot_22</span>
              </a>
              <button
                onClick={() => scrollToSection('contact')}
                className="flex items-center gap-3 caption-text hover:text-white transition-colors duration-300 group"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  textAlign: 'left'
                }}>

                <div
                  className="p-2 rounded-full border border-gray-700 group-hover:border-white transition-colors duration-300">

                  <Mail size={20} />
                </div>
                <span>wilannpro.pix@gmail.com</span>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="caption-text text-center md:text-left">
            © {currentYear} W Shoot. Tous droits réservés. Photographie automobile premium.
          </p>
          <div className="flex gap-6">
            <button
              className="caption-text hover:text-white transition-colors duration-300"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}>

              Mentions Légales
            </button>
            <button
              className="caption-text hover:text-white transition-colors duration-300"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}>

              Confidentialité
            </button>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;